import vision from '../assets/images/vision.png'
import mission from '../assets/images/mission.png'
import values from '../assets/images/values.png'

function ShowContent(){
    return(
        <section className='container-fluid px-3 px-md-5 statement-section'>
            <div className='row statement-content justify-content-center'>
                <div className='col-md-4 col-12 mb-4 mb-md-0'>
                    <div className='statement-card-mission h-100'>
                        <div className="d-flex align-items-center mb-3">
                            <img 
                                src={mission} 
                                alt='mission icon' 
                                className='statement-image me-3' 
                                style={{ width: '48px', height: '48px', filter: 'brightness(0) invert(1)' }}
                            />
                            <h3 className='text1 mb-0 text-white'>
                                Mission Statement
                            </h3>
                        </div>
                        <p className='text2 statement mb-0 text-white'>
                            To foster the holistic development of youth by providing comprehensive educational, health, and empowerment initiatives, ensuring an inclusive and empowered future for all.
                        </p>
                        <div className="mt-auto pt-3">
                            <div className="d-flex align-items-center" style={{ color: 'var(--gender-equality)' }}>
                                <i className="bi bi-target me-2"></i>
                                <small className="fw-semibold">Our Purpose</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='col-md-4 col-12 mb-4 mb-md-0'>
                    <div className='statement-card-vision h-100'>
                        <div className="d-flex align-items-center mb-3">
                            <img 
                                src={vision} 
                                alt='vision icon' 
                                className='statement-image me-3' 
                                style={{ width: '48px', height: '48px', filter: 'brightness(0) invert(1)' }}
                            />
                            <h3 className='text1 mb-0 text-white'>
                                Vision Statement
                            </h3>
                        </div>
                        <p className='text2 statement mb-0 text-white'>
                            Inspiring positive change and unity among civil society organizations through collaborative efforts and shared values.
                        </p>
                        <div className="mt-auto pt-3">
                            <div className="d-flex align-items-center" style={{ color: 'var(--good-health-and-well-being)' }}>
                                <i className="bi bi-eye me-2"></i>
                                <small className="fw-semibold">Our Future</small>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='col-md-4 col-12'>
                    <div className='statement-card-values h-100'>
                        <div className="d-flex align-items-center mb-3">
                            <img 
                                src={values} 
                                alt='values icon' 
                                className='statement-image me-3' 
                                style={{ width: '48px', height: '48px', filter: 'brightness(0) invert(1)' }}
                            />
                            <h3 className='text1 mb-0 text-white'>
                                Our Values
                            </h3>
                        </div>
                        <div className='text2 statement mb-0'>
                            <div className="d-flex flex-wrap gap-2">
                                <span className="badge px-3 py-2 rounded-pill" style={{ 
                                    backgroundColor: 'rgba(255, 174, 0, 0.2)', 
                                    color: 'var(--gender-equality)',
                                    border: '1px solid var(--gender-equality)'
                                }}>Inclusivity</span>
                                <span className="badge px-3 py-2 rounded-pill" style={{ 
                                    backgroundColor: 'rgba(76, 159, 56, 0.2)', 
                                    color: 'var(--good-health-and-well-being)',
                                    border: '1px solid var(--good-health-and-well-being)'
                                }}>Integrity</span>
                                <span className="badge px-3 py-2 rounded-pill" style={{ 
                                    backgroundColor: 'rgba(128, 0, 128, 0.2)', 
                                    color: 'var(--primary-color)',
                                    border: '1px solid var(--primary-color)'
                                }}>Respect</span>
                                <span className="badge px-3 py-2 rounded-pill" style={{ 
                                    backgroundColor: 'rgba(197, 25, 45, 0.2)', 
                                    color: 'var(--quality-education)',
                                    border: '1px solid var(--quality-education)'
                                }}>Innovation</span>
                                <span className="badge px-3 py-2 rounded-pill" style={{ 
                                    backgroundColor: 'rgba(63, 126, 68, 0.2)', 
                                    color: 'var(--climate-action)',
                                    border: '1px solid var(--climate-action)'
                                }}>Collaboration</span>
                            </div>
                        </div>
                        <div className="mt-auto pt-3">
                            <div className="d-flex align-items-center" style={{ color: 'var(--primary-color)' }}>
                                <i className="bi bi-heart me-2"></i>
                                <small className="fw-semibold">Our Principles</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ShowContent;